export default __webpack_public_path__ + "static/media/img1.1acc6e90.png";